const commitTime = 1
const release = "sfu-politik-2025.dirty"

const apiClientBaseURL = "/api/"

// @ts-ignore
if (typeof context !== "undefined" && !context.job) {
    context.response.header("x-commit-time", commitTime)
    context.response.header("x-release", release)
}

module.exports = {
    release,
    commitTime,
    apiClientBaseURL,
    frontendBase: "https://www.familienunternehmen-politik.de/",
    tibiUrl: "https://dev.tibicms.de/",
    kirbyUrl: "https://kirby.familienunternehmen-politik.de/",
    kirbyApiUsername: "mail@webmakers.de",
    kirbyApiPassword: "HhXc2vRTtPK5zvNxv9",
    unlistedToken: "pkmadsfgebneqwrgx",
}
